

<div class="modal-signup modal-content" *ngIf="ShowList">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form1 document">


      <div class="card-header wh-header padding-bottom-0px border-bottom-light2">

        <label class="margin-bottom-0px nav-link-hand"><i class="fas fa-pencil-alt nav-link-hand"></i> Observation</label>

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        




        <div class="row">





          <div class="col-md-8">

            <div class="row">
              <div class="col-md-12 padding-left-2px padding-right-0px">
                <div class="card">

                  <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                    <div class="row border-top border-bottom bk-color-light margin-left-zero">
                      <div class="col-md-6  text-align-center padding-right-0px padding-left-0px border-right-1px">
                        <div class="padding-top-5px"><h4 class="margin-bottom-0px">BHCG</h4></div>
                        <div class="padding-top-5px padding-bottom-5px"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Bhcg</h4></div>

                      </div>

                      <div class="col-md-6 text-align-center padding-right-0px padding-left-0px border-right-1px">

                        <div class="padding-top-15px"><h4 class="">Heamatology</h4></div>
                      </div>
                    </div>


                    <!--<div class="row">
                      <div class="col-md-12 padding-left-30px">
                        <label class="margin-bottom-0px font-size-18px">Selected Observation : A/G RATIO</label>
                      </div>
                    </div>-->


                    <!--<div class="form-body padding-top-5px">

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Order Sequence </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Name </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Lab Department </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="All "> All </option>
                                <option value="Cardiology"> Cardiology </option>
                                <option value="Neurology"> Neurology </option>
                                <option value="Nephrology"> Nephrology </option>
                                <option value="Endocrinology"> Endocrinology </option>
                                <option value="Physiotherapy"> Physiotherapy </option>
                              </select>

                              
                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Profile </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="Male "> Male </option>
                                <option value="Female "> Female </option>

                              </select>

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Service Code </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>
                    </div>-->



                    <div class="row margin-left-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-2 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">

                        <div class="table-component">
                         <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero"
                                  cols="auto,2*,*,*,*,*,*,*">

                          <thead class="font-weight-normal">
                          <tr>

                            <th class="width-50px font-weight-normal">#</th>

                            <th class="padding-left-0px width-150px font-weight-normal">Name</th>

                            <th class="width-120px font-weight-normal">Examination</th>

                            <th class="width-70px font-weight-normal">UOM</th>
                            <th class="font-weight-normal">Group</th>
                            <th class="width-35px font-weight-normal"> </th>


                          </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let obs of observations; let i = index">

                              <td class="text-align-center">
                                <input type="number" class="form-control padding-left-0px" [(ngModel)]="obs.OrderSeq" [name]="'orderSeq_' + i">
                              </td>
                              <td class="padding-left-0px">{{obs.Name}}</td>
                              <td class="">
                                <select class="form-control padding-left-0px padding-right-0px" [(ngModel)]="obs.ExaminationType" [name]="'examType_' + i">
                                  <option value="Investigation"> Investigation </option>
                                  <option value="Microbiology"> Microbiology </option>
                                  <option value="Pathology"> Pathology </option>
                                </select>
                              </td>

                              <td class="text-align-center">
                                <select class="form-control padding-left-0px padding-right-0px" [(ngModel)]="obs.UOM" [name]="'uom_' + i">
                                  <option value="Ratio"> Ratio </option>
                                  <option value="g/dL"> g/dL </option>
                                  <option value="mg/dL"> mg/dL </option>
                                  <option value="IU/L"> IU/L </option>
                                  <option value="%"> % </option>
                                </select>
                              </td>
                              <td class="">
                                <input type="text" class="form-control padding-left-0px" [(ngModel)]="obs.ObservationGroup" [name]="'group_' + i">
                              </td>

                              <td class="">
                                <label class="margin-bottom-0px nav-link-hand" title="Remove" (click)="removeObservation(i)"><i class="fas fa-trash-alt"></i></label>
                              </td>

                            </tr>
                          </tbody>

                           </table>
                        </div>
                      </div>


                        <!--<div class="table-component">
                          <div class="table-responsive overflow-x-hidden">


                            <table class="table1 table-striped margin-left-zero">

                              <thead class="">
                                <tr>
                                  <th class="td-width-3px">Code</th>

                                  <th class="padding-left-0px">Name</th>

                                  <th class="">Lab Department </th>
                                  <th class="">Profile</th>



                                  <th class="">Service Code</th>

                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr>
                                  <td><a class="nav-link-hand table-anchor">1</a></td>
                                  <td><a class="nav-link-hand table-anchor padding-left-0px">ACA IGG</a></td>



                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Serology</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Female</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">16</a>

                                  </td>


                                </tr>

                                <tr>
                                  <td><a class="nav-link-hand table-anchor">2</a></td>
                                  <td><a class="nav-link-hand table-anchor padding-left-0px">ACA-IGM (ANTI-CARDIOLIPIN IGM)</a></td>



                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Harmonal Assay</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Female</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">17</a>

                                  </td>


                                </tr>

                                <tr>
                                  <td><a class="nav-link-hand table-anchor">1</a></td>
                                  <td><a class="nav-link-hand table-anchor padding-left-0px">ACA IGG</a></td>



                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Serology</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Female</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">16</a>

                                  </td>


                                </tr>

                                <tr>
                                  <td><a class="nav-link-hand table-anchor">2</a></td>
                                  <td><a class="nav-link-hand table-anchor padding-left-0px">ACA-IGM (ANTI-CARDIOLIPIN IGM)</a></td>



                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Harmonal Assay</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Female</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">17</a>

                                  </td>


                                </tr>

                                <tr>
                                  <td><a class="nav-link-hand table-anchor">1</a></td>
                                  <td><a class="nav-link-hand table-anchor padding-left-0px">ACA IGG</a></td>



                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Serology</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">Female</a>

                                  </td>

                                  <td class="">
                                    <a class="nav-link-hand table-anchor">16</a>

                                  </td>


                                </tr>

                              </tbody>

                            </table>
                          </div>
                        </div>-->

                      </div>
                    </div>  



                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4  padding-right-0px border-right">
            <div class="card">
              <div class="card-header wh-header header3 padding-left-14px font-size-16px padding-bottom-4px bk-color-light">
                Observations
                
                  <button type="button" class="btn btn-new1 btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                  
              </div>
              <div class="card-body padding-top-0px margin-left-zero padding-left-0px padding-right-0px bk-color-light padding-bottom-0px">
                <div class="row  padding-top-5 padding-bottom-5px margin-right-0px">
                  <div class="col-md-9 padding-right-0px margin-left-14px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                  <!--<div class="col-md-1">
                    <label class="margin-bottom-0px nav-link-hand"><i class="fas fa-pencil-alt nav-link-hand"></i></label>
                  </div>-->

                </div>
                <div class="chatsd product-chart-wrapper product-chat-width-92 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div class="table-component actor-table">

                    <div class="table-responsive padding-right-11px">


                      <table class="table table-striped table2">
                        <tbody>
                          <tr *ngFor="let item of filteredMasterObservations">
                            <td class="td-padding-2px">

                              <div class="row margin-left-zero margin-right border4 margin-top-3px">
                                <div class="col-md-2 margin-tb-auto padding-lr-2px">
                                  <button type="button"
                                          class="btn btn-sm plus-button"
                                          (click)="addObservation(item.Name)">
                                    <i class="fas fa-plus font-size-11p"></i>
                                  </button>
                                </div>
                                <div class="col-md-10 margin-tb-auto padding-left-11px">
                                  <label class="margin-bottom-0px color3 nav-link-hand" (click)="addObservation(item.Name)">{{item.Name}}</label>

                                </div>
                              </div>

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>






      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="ModalClose()">Back</button>
        <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
      </div>
    </div>
  </div>
</div>




